export const getEnvironmentConfig = () => {
    return {
        apiUrl: process.env.REACT_APP_API_URL,
        stripeKey: process.env.REACT_APP_STRIPE_KEY,
        environment: process.env.NODE_ENV
    };
};

// Export direct pour utilisation simple
export const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    stripeKey: process.env.REACT_APP_STRIPE_KEY,
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production'
};
